"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _password_input = require("../../ui/input/password_input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = function _default(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "auth0-sso-notice-container"
  }, /*#__PURE__*/_react.default.createElement("span", null, _password_input.IconSvg), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "auth0-sso-notice"
  }, children));
};
